import React, { useEffect, useState } from "react";
import { money } from "../utilities/currency";
import { Header } from "../components/ui/header";
import axios from "axios";
import { Footer } from "../components/ui/footer";
type EventDetailPageProps = {
    event: any,
    onBack: () => void,
}
const T = {
    offer: "✨ Spesialtilbud – Betal 99 kr, få 198 kr i ringe kreditt! ✨",
    signIn: "Logg inn",
    join: "Bli med",
    allAdvisors: "Alle veiledere",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Verv & få gratis reading!",
    referBody: "Verv 5 betalende kunder og få en GRATIS 15‑min reading hos en toppveileder.",
    blogTitle: "Fra Mystic‑bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e‑post.",
    read: "Les",
    invite: "Inviter venner",
    sponsored: "Sponset",
    ad: (n: number) => `Annonse ${n}`,
    adBlurb: "Annonser produkter, apper eller arrangementer her.",
    learnMore: "Les mer",
    connectNow: "Koble til nå",
    from: "fra",
    minutes: "min",
    verified: "Verifisert",
    categories: [
        "Kjærlighetsreading",
        "Klarsynt reading",
        "Tarot‑reading",
        "Astrologi & Horoskop",
        "Englebudskap",
        "Orakel‑veiledning",
        "Drømmetydning",
        "Åndelig medium",
    ],
    hero: {
        name: "Klarsynte Eirik",
        tag: "Kjærlighetsekspert",
        blurb:
            "Mitt løfte: Jeg er her for deg. Når det er vanskelig å vite hvem man kan stole på, er ekte nærvær alt.",
        getReading: "Bestill reading",
    },
    footer: {
        getApp: "Få appen for klarhet hvor du enn er.",
        explore: "Utforsk",
        special: "Spesialiteter",
        more: "Mer",
        advisors: "Veiledere",
        blog: "Bloggen vår",
        applyCode: "Bruk kampanjekode",
        support: "Kundesupport",
        about: "Om oss",
        apply: "Veileder? Søk her",
        privacy: "Personvern",
        terms: "Vilkår",
    },
    wallet: {
        title: "Kjøp ringeminutter",
        intro:
            "Minutter lagres i din Mystic‑wallet og kan brukes hos alle veiledere (chat / samtale / video).",
        numLabel: "Telefonnummeret du ringer fra",
        amount: "Velg beløp",
        buy: (amt: number) => `Kjøp ${money(amt)} kreditt`,
        learn: "Les mer om betalingsmåter",
        err: "Skriv inn et gyldig telefonnummer",
        otp: (n: string) => `Kode sendt til ${n}. Skriv den inn for å bekrefte.`,
        enterOtp: "Skriv inn kode",
        verify: "Bekreft & legg til kreditt",
        cancel: "Avbryt",
        success: (amt: number) => `${money(amt)} lagt til i lommeboken!`,
        pm1: "Vipps MobilePay",
        pm2: "Kort (krever registrering på ditt mobilnummer)",
        nolgin: "Ingen innlogging nødvendig for Vipps MobilePay – ring direkte.",
    },
};
// export default function EventDetailPage({ event, onBack }) {
export default function EventDetailPage({ event, onBack }: EventDetailPageProps) {
    // TEMP: Dummy e so the page is visible in preview
    const dummyEvent = {
        title: "Digital Rådgivning – Introduksjonskurs",
        description:
            "Et komplett introduksjonsforedrag om digital rådgivning, livestreams og hvordan Chamcore-plattformen muliggjør fjernlevering av tjenester i høy kvalitet.",
        price: 0,
        live: true,
        uploaded_file:
            "https://images.unsplash.com/photo-1516321497487-e288fb19713f?auto=format&fit=crop&w=1200&q=80",
    };

    const e = event || dummyEvent;

    return (
        <div className={"bg-white text-gray-900"}>

            <div className="w-full min-h-screen bg-gradient-to-b from-white to-slate-50 py-12 px-6 animate-fadeIn">
                <button
                    onClick={onBack}
                    className="mb-6 text-blue-600 hover:text-blue-800 text-sm font-medium"
                >
                    ← Tilbake
                </button>
                <div className="max-w-4xl mx-auto bg-white/80 backdrop-blur-xl shadow-xl rounded-3xl overflow-hidden border border-white/20">
                    <div className="relative h-80 w-full">
                        <img src={e.uploaded_file} className="w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/70" />
                        {e.status === "live" && (
                            <div className="absolute top-4 left-4 bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md animate-pulse">
                                LIVE NÅ
                            </div>
                        )}
                        <h1 className="absolute bottom-4 left-6 text-4xl font-bold text-white drop-shadow-lg">
                            {e.title}
                        </h1>
                    </div>

                    <div className="p-10">
                        {/* Date & Time */}
                        <div className="mb-8">
                            <p className="text-slate-900 font-semibold text-lg">Dato & tid</p>
                            <p className="text-slate-600 text-md">{e.formatted_start_date_time}</p>
                        </div>

                        <p className="text-slate-700 mb-6 text-lg leading-relaxed">
                            {e.description}
                        </p>

                        <div className="flex items-center gap-4 mb-10">
                            <img
                                src="https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=200&q=80"
                                className="w-20 h-20 rounded-full object-cover"
                            />
                            <div>
                                <p className="font-semibold text-slate-900 text-lg">Veronica Hansen</p>
                                <p className="text-sm text-slate-600">Sertifisert Chamcore ekspert og kursansvarlig</p>
                            </div>
                        </div>

                        <div className="flex justify-between items-center">
                            <span className="text-2xl font-semibold text-purple-700">
                                {e.broadcast_price === 0 ? "Gratis" : `${e.broadcast_price} kr`}
                            </span>
                            <button className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-purple-600 text-white text-lg font-medium hover:bg-purple-700 transition">
                                {e.broadcast_price === 0 ? "Delta gratis" : "Kjøp tilgang"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}
